<template>
  <div>
    <div
      class="hs-head"
      :class="{'SquareBg': (SquareBg?SquareBg:false),'waveBg': (waveBg?waveBg:false),'irregularBg': (irregularBg?irregularBg:false)}"
      v-if="!page"
      :style="{'background-color':(bgcolor?bgcolor:'#fff')}"
    >
      <div class="back-btn" onclick="history.go(-1)">
        <img src="~@/assets/images/head/back.png" class="white-back" alt />
        <img src="~@/assets/images/head/back-g.png" class="gary-back" alt />
      </div>
      <div class="center-p" v-text="(title?title:'')"></div>
    </div>
    <div class="hs-head hs-head-page" v-if="page" :style="{'height': (BgHeight?BgHeight:'7.5rem')}">
      <router-link
        :to="curRole=='store'?'/Store/Other':'/Grapher/Center'"
        class="hs-pic"
        v-if="!pic"
      >
        <img :src="userInfo.headIcon" alt v-if="userInfo.headIcon" />
        <img src="~@/assets/images/center/head.png" alt v-else />
      </router-link>
      <div class="center-p" :style="{'margin-left':(pic?'0.78rem':'0')}" v-text="(title?title:'')"></div>
      <div class="right-nav" v-if="displayMenu">
        <img src="~@/assets/images/head/r.png" alt @click="showMenu=!showMenu" />
      </div>
    </div>
    <van-action-sheet v-model="showMenu" cancel-text="取消" :actions="menus" @select="onSelect" />
  </div>
</template>

<script>
import { ActionSheet } from "vant";
import { getUserByCookie } from "@/api/m/user";
import { getAllRoles, getCurRole, setRole, setToken } from "@/utils/auth"; // get token from cookie
import moment from "moment";

export default {
  name: "hshead",
  data() {
    return {
      userInfo: {},
      displayMenu: false,
      showMenu: false,
      menus: null,
      curRole: ""
    };
  },
  created() {
    getUserByCookie().then(response => {
      this.userInfo = response;
    });
    const allRoles = getAllRoles();
    this.curRole = getCurRole();
    //console.info('allRoles', allRoles)
    //this.displayMenu = allRoles.split(',').length > 1
    this.displayMenu = true;
    //菜单项
    let menus = [];
    if (allRoles.split(",").length > 1) {
      if (this.curRole == "store") {
        menus.push({
          name: "商家版",
          className: "store",
          subname: "当前版本",
          disabled: true
        });
        menus.push({ name: "切换至摄影师版", className: "grapher" });
        menus.push({ name: "公开抢单教程视频", className: "store1" });
        menus.push({ name: "基础教程视频", className: "store2" });
      } else if (this.curRole == "grapher") {
        menus.push({ name: "切换至商家版", className: "store" });
        menus.push({
          name: "摄影师版",
          className: "grapher",
          subname: "当前版本",
          disabled: true
        });
        menus.push({ name: "教程视频", className: "Photographer" });
      }
    }
    menus.push({ name: "开店教程", className: "course" });
    menus.push({ name: "退出登录", className: "logout" });
    this.menus = menus;
    console.log(menus);
  },
  methods: {
    onSelect(item, index) {
      let self = this;
      this.show = false; // 点击选项时默认不会关闭菜单，可以手动关闭
      console.info("item", item, item.name, item.className, index);

      const className = item.className;
      if (
        className == "store1" ||
        className == "store2" ||
        className == "Photographer"
      ) {
        window.location.href = "http://static.lshoot.com/video/" + className + ".mp4";
        return false;
      }

      if (className == "course") {
        this.$router.push({
          path: "/Course"
        });
        return false;
      }
      if (className == "logout") {
        //退出登录
        setToken(
          "",
          moment()
            .add(-1, "days")
            .format("YYYY-MM-DD")
        );
        window.localStorage.isAutoLogin = "false";
        // 删除cookie
        self.delCookie("lshoot-qupaipai-hkm-account-token");
        self.delCookie("lshoot-qupaipai-hkm-userinfo");
        self.delCookie("lshoot-qupaipai-hkm-account-roles");
        self.delCookie("openid");
        window.location.href = "/user/login";
        
      }

      setRole(
        "",
        className,
        moment()
          .add(365, "days")
          .format("YYYY-MM-DD")
      );
      if (className == "store") {
        window.location.href = "/Store/Other";
      } else {
        window.location.href = "/Grapher/Center";
      }
    }
  },
  props: [
    "title",
    "bgcolor",
    "page",
    "BgHeight",
    "BgImg",
    "SquareBg",
    "waveBg",
    "pic",
    "irregularBg"
  ],
  components: {
    "van-action-sheet": ActionSheet
  }
};
</script>

<style lang="less" scoped>
.hs-head {
  height: 0.9rem;
  line-height: 0.9rem;
  display: flex;
  width: 100%;
  align-items: center;

  &.SquareBg,
  &.waveBg,
  &.irregularBg {
    background: url(~@/assets/images/head/Square.png) top center no-repeat;
    background-size: 7.5rem 4.28rem;
    height: 4.28rem;
    align-items: flex-start;
    .back-btn {
      margin-top: 0.28rem;
      img.white-back {
        display: block;
      }
      img.gary-back {
        display: none;
      }
    }
    .center-p {
      color: #fff;
    }
  }
  &.waveBg {
    background: url(~@/assets/images/head/wave.png) top center no-repeat;
    background-size: 7.5rem 5.18rem;
    height: 5.18rem;
  }
  &.irregularBg {
    background: url(~@/assets/images/head/oval.png) top center no-repeat;
    background-size: 7.5rem;
    height: 7.5rem;
  }
  &.whiteBg {
    background: #fff;
  }
  .back-btn {
    width: 0.38rem;
    padding-left: 0.4rem;
    img {
      width: 0.18rem;
      height: 0.29rem;
      &.white-back {
        display: none;
      }
      &.gary-back {
        display: block;
      }
    }
  }
  .center-p {
    width: 7.5- (0.38+0.4) * 2rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    font-size: 0.38rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #333333;
  }
  &.hs-head-page {
    background: url(~@/assets/images/head/oval.png) top center no-repeat;
    background-size: 7.5rem;
    height: 7.5rem;
    align-items: flex-start;
    color: #fff;
    .hs-pic {
      width: 0.68rem;
      height: 0.68rem;
      border-radius: 50%;
      margin-left: 0.4rem;
      margin-top: 0.15rem;
      overflow: hidden;
      display: block;
      border: solid 0.03rem rgba(255, 255, 255, 0.14);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .center-p {
      flex: 1;
      color: #fff;
    }
    .right-nav {
      width: 0.38rem;
      margin-right: 0.4rem;
      margin-top: 0.25rem;
      img {
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/hshead.vue